/**
 * Splits a section's fields into the three roles the Videos section has, from
 * the payload alone:
 *
 *   picker    options_are_sources false, has options  -> pick whole playlists
 *   companion options_are_sources true, no options    -> videos inside those
 *                                                        playlists, sources
 *                                                        only known at runtime
 *   sources   options_are_sources true, has options   -> videos out of its own
 *                                                        playlist (reels)
 *
 * A section holding both a picker and a source field is rendered as tabs.
 */
export const splitVideoFields = (section) => {
  const fields = (section && section.fields) || [];
  const lists = fields.filter((f) => f.kind === 'list');

  const picker = lists.find(
    (f) => !f.options_are_sources && (f.options || []).length
  );
  const companion = lists.find(
    (f) => f.options_are_sources && !(f.options || []).length
  );
  const sources = lists.filter(
    (f) => f.options_are_sources && (f.options || []).length
  );

  return {
    picker,
    companion,
    sources,
    rest: fields.filter(
      (f) => f !== picker && f !== companion && !sources.includes(f)
    ),
    isTabbed: !!picker && (!!companion || sources.length > 0),
  };
};

/** The `list` query of an embed URL, or null. Never parsed by regex. */
export const listIdOf = (option) => {
  try {
    return new URL(option.embed_url).searchParams.get('list');
  } catch (e) {
    return null;
  }
};
